<script setup>
import LSection from "@/components/layout/LSection.vue";
import People from "@/components/About/People.vue";
import EmailIcon from "@/components/About/EmailIcon.vue";
</script>

<template>
  <LSection>
    <template #body>
      <div>
        <div class="heading1">
          Contact
          <hr class="gradientLine" />
        </div>
        <p class="relative">
          Please don't hesitate to get in touch with us if you have any
          questions, comments, or feedback. For general inquiries or questions,
          please contact
          <a
            href="mailto: eqrc@mgmt.au.dk"
            class="gradientText pr-1 hoverUnderline cursor-pointer"
          >
            eqrc@mgmt.au.dk
          </a>
          <EmailIcon
            email="mailto: eqrc@mgmt.au.dk"
            class="absolute -bottom-0.5"
          />
        </p>
        <People />
      </div>
    </template>
  </LSection>
</template>

<style scoped></style>
